export class DialogPropsFormacao {
    constructor(t) {
        this.visible = {
          type: Boolean,
          default: false,
        };
        this.edit = {
          type: Boolean,
          default: false,
        };
        this.content = {
          type: Object,
          default: () => new t(),
        };
        this.isViewMode = {
            type: Boolean,
            default: false,
        };
    }
    static Build() {
      return new DialogPropsFormacao(Object);
    }
  }
  